import { styled } from '@mui/material/styles';

import { BRAND } from '../../shared/theme/paletteDark';
import { FONTS } from '../../shared/theme/typography';

/**
 * My Schedule's half of a phone's header, where Share My Schedule was: how many
 * events are Going and how many Maybe.
 */

const Line = styled('div')({
  height: 30,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontFamily: FONTS.display,
  fontSize: 12.5,
  fontWeight: 700,
  color: BRAND.parchment,
  whiteSpace: 'nowrap',
  '& .maybe': { opacity: 0.6 },
  '& .dot': { opacity: 0.45 },
});

export default function PhoneScheduleCount({ going, maybe }: { going: number; maybe: number }) {
  return (
    <Line aria-label={`${going} going, ${maybe} maybe`}>
      <span>{going} going</span>
      <span className="dot" aria-hidden="true">
        ·
      </span>
      <span className="maybe">{maybe} maybe</span>
    </Line>
  );
}
